import classNames from 'classnames'
import { Icon } from '@winnin/ds-icon'
import { ContextMenu } from '@winnin/winnin_ui.components.context-menu'
import { Icon as BitIcon } from '@winnin/winnin_ui.components.icon'

import type { ISelectWithIconsProps } from './select-with-icon.types'

import './select-with-icon.styles.scss'

export function SelectWithIcon({ options, position, className, icon, disabled }: ISelectWithIconsProps) {
  const selected = options.find(option => Boolean(option.isSelected)) ?? options[0]
  const button = (
    <button type="button" className="SelectWithIcon-button" disabled={disabled}>
      <Icon name={icon} />
      <span className="SelectWithIcon-selected">{selected.label}</span>
      <BitIcon icon="arrowDown" width={18} height={18} fill="var(--color_neutral_800)" />
    </button>
  )
  return (
    <div className={classNames(['SelectWithIcon-wrapper', className])}>
      {disabled ? (
        button
      ) : (
        <ContextMenu menuItems={options} position={position}>
          {button}
        </ContextMenu>
      )}
    </div>
  )
}
